import React, { FC } from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';
import styled, { css, useTheme } from 'styled-components';
import { media } from 'src/common/styles/breakpoints';

const Container = styled.div`
  border-radius: 6px;
  box-shadow: none;
  overflow: hidden;
  min-height: 4.9375rem;

  ${media.w.min.px576(css`
    box-shadow: ${({ theme }) => theme.shadows.drop1};
    height: 5rem;
  `)}
`;

export const AspspListItemSkeleton: FC<IContentLoaderProps> = (props) => {
  const theme = useTheme();

  return (
    <Container>
      <ContentLoader
        height={140}
        speed={2}
        viewBox="0 0 212 140"
        backgroundColor={theme.colors.darkGrey}
        foregroundColor={theme.colors.grey1}
        style={{ display: 'block', width: '100%' }}
        preserveAspectRatio="xMidYMid slice"
        {...props}
      >
        <rect x="0" y="0" rx="6" ry="6" width="212" height="140" />
      </ContentLoader>
    </Container>
  );
};
